import { Component, OnInit,Input} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { LabelsKeys } from '../import/LabelsKeys';
@Component({
  selector: 'app-import-avis-confirmation-modal',
  templateUrl: './import-avis-confirmation-modal.component.html',
  styleUrls: ['./import-avis-confirmation-modal.component.scss']
})
export class ImportAvisConfirmationModalComponent implements OnInit {
  
	@Input()
	public boampAvis: any;

	@Input()
	public refConsultation: string;

  public labelsKeys: LabelsKeys = new LabelsKeys();
	
  constructor(public activeModal: NgbActiveModal) {
    
   }
	
  ngOnInit(): void {
	
  }
  exitModal(param:boolean){
	this.activeModal.close(param);
  }
}
